import CryptoJS from "crypto-js";
import { config } from "../../../config";

const useDecryptData = (passKey = config.aesPassKey) => {

    const decryptData = (encryptedData) => {

        if (!encryptedData) {
            throw new Error("Decryption failed: Encrypted data is empty.");
        }
        try {
            // Decode the Base64-encoded encrypted data
            const encryptedBytes = CryptoJS.enc.Base64.parse(encryptedData);
    
            // Decrypt using AES with the same key
            const bytes = CryptoJS.AES.decrypt(
                { ciphertext: encryptedBytes },
                CryptoJS.enc.Utf8.parse(passKey), // Ensure the key is parsed as Utf8
                {
                    mode: CryptoJS.mode.ECB, // Match the mode used in J2EE
                    padding: CryptoJS.pad.Pkcs7, // Match the padding used in J2EE
                }
            );
    
            // Convert decrypted bytes to a UTF-8 string
            const decryptedData = bytes.toString(CryptoJS.enc.Utf8);
            if (!decryptedData) {
                throw new Error("Decryption failed: No data returned.");
            }
    
            // Parse the decrypted JSON string
            return JSON.parse(decryptedData);
        } catch (error) {
            console.error("Decryption error:", error.message);
            throw new Error("Decryption failed: Invalid data or passkey.");
        }
    };

    return { decryptData };
}

export default useDecryptData;